// Coupon modal timing for [data-newsletter-popup] (snippets/newsletter-popup.liquid).
// State lives in this browser's localStorage, like the wishlist: no cookie, no
// app. Shows from the Nth page of a visit after a delay, stays away for the
// re-show window once shown, and never returns after a subscription.
(() => {
  const KEY = 'maru:newsletter-popup';
  const PENDING_KEY = `${KEY}:pending`;
  const VISIT_GAP = 30 * 60 * 1000;
  const DAY = 24 * 60 * 60 * 1000;
  const RETRY = 2000;

  const popup = document.querySelector('[data-newsletter-popup]');
  if (!popup || typeof popup.showModal !== 'function') return;

  const read = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(KEY) || '{}');
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (error) {
      return {};
    }
  };

  // Storage can be blocked (private mode, disabled site data). Without it the
  // modal could not remember being closed, so it stays hidden.
  const write = (state) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(state));
      return true;
    } catch (error) {
      return false;
    }
  };

  const session = {
    get: () => {
      try {
        return sessionStorage.getItem(PENDING_KEY);
      } catch (error) {
        return null;
      }
    },
    set: () => {
      try {
        sessionStorage.setItem(PENDING_KEY, '1');
      } catch (error) {}
    },
    clear: () => {
      try {
        sessionStorage.removeItem(PENDING_KEY);
      } catch (error) {}
    },
  };

  const now = Date.now();
  const state = read();

  // A visit ends after 30 minutes without a page load. sessionStorage would
  // lose the count when a product opens in a new tab. Only a change of path
  // counts: reloads, filters, pagination and the collection's sort_by
  // redirect (sections/collection.liquid) stay on the same page.
  if (now - (state.lastSeen || 0) > VISIT_GAP) {
    state.views = 1;
  } else if (state.lastPath !== location.pathname) {
    state.views = (state.views || 0) + 1;
  }
  state.lastPath = location.pathname;
  state.lastSeen = now;

  // Any customer form on the site (footer, release notify, this modal) lands
  // back here with customer_posted=true and renders its success state.
  const result = popup.querySelector('[data-newsletter-popup-state]')?.dataset.newsletterPopupState;
  if (result === 'success' || new URLSearchParams(location.search).get('customer_posted') === 'true') {
    state.subscribed = true;
  }

  if (!write(state)) return;

  popup.addEventListener('click', (event) => {
    // Backdrop clicks target the dialog itself, but so do clicks on its
    // padding: compare against the box.
    const box = popup.getBoundingClientRect();
    const outside =
      event.target === popup &&
      (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
    if (outside || event.target.closest('[data-newsletter-popup-close]')) popup.close();
  });

  popup.querySelector('form')?.addEventListener('submit', () => session.set());

  // The form posts natively and the page reloads: reopen to show the result.
  if (session.get() && result !== 'idle') {
    session.clear();
    popup.showModal();
    return;
  }
  session.clear();

  const minPages = Number(popup.dataset.minPages) || 1;
  const delay = (Number(popup.dataset.delay) || 0) * 1000;
  const reshow = (Number(popup.dataset.reshowDays) || 0) * DAY;

  if (state.subscribed) return;
  // Arrived through a /discount/CODE link (the coupon email, possibly opened
  // in another browser): this visitor already has the offer.
  if (/(?:^|;\s*)discount_code=/.test(document.cookie)) return;
  if (state.shownAt && now - state.shownAt < reshow) return;
  if (state.views < minPages) return;
  if (window.Shopify?.designMode) return;

  // Never interrupt the search overlay, gallery or filter panel, and do not
  // open in a background tab.
  const open = () => {
    if (popup.open) return;
    if (document.hidden || document.querySelector('dialog[open]')) {
      setTimeout(open, RETRY);
      return;
    }
    // Recorded on show, not on close: the visitor may leave the page with the
    // modal still open, and the close event is not reliable in background tabs.
    const latest = read();
    latest.shownAt = Date.now();
    write(latest);
    popup.showModal();
  };

  setTimeout(open, delay);
})();
